module.exports = __webpack_public_path__ + "r-v3/img/speaker_off_white.41ca74ee.svg";